import Handlebars from "handlebars";
import { createSlug } from "./app.common";

const searchForm = document.getElementById('find-architect');
const searchResult = document.getElementById('search-result');
const resultContainer = searchResult?.querySelector('.tile-grid__grid');
const practiceTileTemplateId = "practice-tile-template";
const individualTileTemplateId = "individual-tile-template";

const typeSelector = searchForm?.querySelector('#find-architect #type');
const regionSelector = searchForm?.querySelector('#find-architect #region');
const keywordInput = searchForm?.querySelector('#find-architect #keyword');
const specialtyFilters = document.querySelector('#find-architect .search-filters__button-group-scroll');
const loadMoreButton = document.querySelector(".tile-grid__pagination button");
const locationPopupButton = document.querySelector("#architect-location-popup");
const categoryPopupButton = document.querySelector("#architect-project-type-popup");

let currentActiveSpecialityButton = null;
let currentPage = 1;
const itemsPerPage = 8;

const searchModel = {
    get specialty() { return getActiveSpecialties() },
    get type() { return typeSelector?.value },
    get region() { return regionSelector?.value },
    get keyword() { return keywordInput?.value }
}

const getActiveSpecialties = () => {
    const activeValues = $('.button.is-active').map(function() {
        return $(this).val();
        }).get().join(',');
    return activeValues;;
}
const renderResult = ({ data, totalItems }, append = false) => {

    if (searchModel.type === '1') {
        searchResult.classList.add('tile-grid--practice');
        searchResult.classList.remove('tile-grid--architect');
        searchResult.querySelector('.result-type').innerText = totalItems == 0 ? "No matched results found" : "Practices";
        searchResult.querySelector('.result-number').innerText = totalItems == 0 ? "0" : totalItems;
        if(totalItems > 0)
        data.forEach(profile => { profile.profileUrl = `/practice/${(profile.nameSlug)}/${profile.id}`});
    }
    else {
        searchResult.classList.add('tile-grid--architect');
        searchResult.classList.remove('tile-grid--practice');
        searchResult.querySelector('.result-type').innerText = totalItems == 0 ? "No matched results found " : "Individuals";
        searchResult.querySelector('.result-number').innerText = totalItems == 0 ? "0" : totalItems;
    }

    const source = document.getElementById(searchModel.type === "1" ? practiceTileTemplateId : individualTileTemplateId).innerHTML;
    const template = Handlebars.compile(source);
    const htmlResults = template({ results: data });

    searchResult.querySelector('.result-number').innerText = `(${totalItems})`;

    if (append) {
        resultContainer.innerHTML = resultContainer.innerHTML.concat(htmlResults);
    } else {
        resultContainer.innerHTML = htmlResults;
    }

    searchResult.style.display = "block";
};

const fetchSearchResult = async (currentPage = 1, itemsPerPage = 8) => {

    let requestUrl = `${window.location.protocol}//${window.location.host}/api/find-architect/${searchModel.type == 1 ? "practices" : "individuals"}`;

    const searchParams = new URLSearchParams();
    if (searchModel.type == 1) {
        if (searchModel.region) searchParams.append('region', searchModel.region);
        if (searchModel.keyword) searchParams.append('keyword', searchModel.keyword);
        if (searchModel.specialty) searchParams.append('specialty', searchModel.specialty)
    }
    else {
        if (searchModel.region) searchParams.append('region', searchModel.region);
        if (searchModel.keyword) searchParams.append('keyword', searchModel.keyword);
    }

    searchParams.append('currentPage', currentPage);
    searchParams.append('itemsPerPage', itemsPerPage);
    requestUrl = `${requestUrl}?${searchParams.toString()}`;
    try {
        const response = await fetch(requestUrl);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Fetching result failed:', error);
        return null;
    }
};

const updateLoadMoreButton = (totalItems) => {
    const hasMore = currentPage * itemsPerPage < totalItems;
    loadMoreButton.style.display = hasMore ? "inline-flex" : "none";
};

const resetForm = () => {
    resultContainer.innerHTML = "";
    keywordInput.value = "";
    specialtyFilters.querySelectorAll('.search-filters__button-group button.is-active').forEach(x => x.classList.remove('is-active'));
    searchResult.style.display = "none";
    currentActiveSpecialityButton = null;
}

const updateQueryString = (key, value) => {
    const url = new URL(window.location);
    const params = url.searchParams;

    const existingValue = params.get(key);

    if (existingValue && key === 'category') {
        const values = existingValue.split(',').map(v => v.trim());
        const valueIndex = values.indexOf(value);

        if (valueIndex > -1) {
            values.splice(valueIndex, 1);
        } else {
            values.push(value);
        }

        // Join the array back into a comma-separated string
        if (values.length > 0) {
            params.set(key, values.join(','));
        } else {
            params.delete(key);
        }
    } else {
        // If the key doesn't exist, set it with the new value
        params.set(key, value);
    }
    window.history.pushState({}, '', url);
};

document.addEventListener("DOMContentLoaded", () => {

    if (searchForm) {
        typeSelector.addEventListener('change', async () => {
            specialtyFilters.style.display = searchModel.type === '2' ? "none" : "flex";
            updateQueryString('type', typeSelector.selectedOptions[0].innerText);
            resetForm();
            const result = await fetchSearchResult();
            renderResult(result);
            updateLoadMoreButton(result.totalItems);
        });

        searchForm.querySelectorAll('.search-filters__button-group button').forEach(async button => {
            button.addEventListener('click', async () => {
                currentActiveSpecialityButton = button;
                updateQueryString('category', button.innerText);

                if (button.classList.contains('is-active')) {
                    button.classList.remove('is-active');
                } else {
                    button.classList.add('is-active');
                }
                const result = await fetchSearchResult();
                renderResult(result);
                updateLoadMoreButton(result.totalItems);
            });

            if (button.classList.contains('is-active')) {
                currentActiveSpecialityButton = button;
                const result = await fetchSearchResult();
                renderResult(result);
                updateLoadMoreButton(result.totalItems);
            }
        });


        regionSelector.addEventListener('change', async (e) => {
            updateQueryString('region', e.target.selectedOptions[0].innerText);
            const result = await fetchSearchResult();
            resetForm();
            renderResult(result);
            updateLoadMoreButton(result.totalItems);
        });

        keywordInput.addEventListener('input', async () => {
            if (searchModel.keyword.length < 3 && searchModel.keyword.length != 0) {
                return;
            }
            const result = await fetchSearchResult();
            renderResult(result);
            updateLoadMoreButton(result.totalItems);
        });

        loadMoreButton.addEventListener('click', async () => {
            const result = await fetchSearchResult(++currentPage, itemsPerPage);
            if(result.totalItems > 0){
                renderResult(result, true);
            }
            updateLoadMoreButton(result.totalItems);
        });

        const fetchDataFirstLoad = async () => {
            const result = await fetchSearchResult();
            renderResult(result);
            updateLoadMoreButton(result.totalItems);
        }
        //execute first time
        if (window.location.pathname == '/find-an-architect/' && window.location.search == ""){
            fetchDataFirstLoad();
        }
    }

    categoryPopupButton?.addEventListener('click', toggleArchitectProjectTypePopup);
    locationPopupButton?.addEventListener('click', toggleArchitectLocationPopup);

    document.querySelectorAll('.block-find-architect__menu-list-button').forEach(btn => {
        btn.addEventListener('click', (e) => {
            const menu = e.target.closest('.block-find-architect__menu');
            if (!menu) return;

            const menuButton = menu.querySelector('.block-find-architect__menu-button');

            menuButton.innerText = btn.innerText;
            menuButton.value = btn.value;
        });
    });

    var findButton = document.querySelector('.block-find-architect__button button');

    if (findButton) {
        findButton.addEventListener('click', (e) => {
            e.preventDefault();

            const href = e.target.getAttribute('data-href');
            const selectedRegion = document.querySelector('#architect-location-popup button').innerText;
            const selectedCategory = document.querySelector('#architect-project-type-popup button').innerText;
            const url = new URL(href, window.location.origin);
            const params = new URLSearchParams(window.location.search);
            params.set('type', 'Practice');
            params.set('region', selectedRegion);
            params.set('category', selectedCategory);

            window.location.href = `${url}?${params.toString()}`;
        });
    }
});


